import { useMemo, useState } from "react";
import { usePatientList } from "../../hooks/usePatientList";
import { useCaseSession } from "../../state/CaseSessionContext";

export function TopBar() {
  const { data: patients, isLoading } = usePatientList();
  const { selectedCaseId, setSelectedCaseId, isDirty } = useCaseSession();
  const [searchText, setSearchText] = useState("");

  const filteredPatients = useMemo(() => {
    const q = searchText.trim().toLowerCase();

    if (!q) {
      return patients;
    }

    return patients.filter((item) => {
      return (
        item.patientName.toLowerCase().includes(q) ||
        item.caseName.toLowerCase().includes(q) ||
        item.patientId.toLowerCase().includes(q) ||
        item.caseId.toLowerCase().includes(q)
      );
    });
  }, [patients, searchText]);

  function handleChangeCase(nextCaseId: string): void {
    if (!nextCaseId) {
      setSelectedCaseId(null);
      return;
    }

    if (nextCaseId === selectedCaseId) {
      return;
    }

    if (isDirty) {
      const confirmed = window.confirm(
        "You have unsaved changes. Switching patient will discard them. Continue?"
      );

      if (!confirmed) {
        return;
      }
    }

    setSelectedCaseId(nextCaseId);
  }

  return (
    <header className="top-bar">
      {/* Left: Branding */}
      <div className="top-bar__left">
        <div className="brand-badge">D</div>
        <div>
          <div className="brand-title">DCube</div>
          <div className="brand-subtitle">Interactive 3D Innovation Showcase</div>
          <div className="brand-tagline">Learning · Visualization · Design Automation</div>
        </div>
      </div>

      {/* Right: Controls only */}
      <div className="top-bar__right top-bar__right--stacked">
        <div className="top-bar__controls">
          <input
            className="top-search"
            type="text"
            placeholder="Search patient, case, ID..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <div className="top-select-group">
            <label className="top-select-label" htmlFor="top-case-select">
              Case
            </label>
            <select
              id="top-case-select"
              className="top-select"
              value={selectedCaseId ?? ""}
              onChange={(e) => handleChangeCase(e.target.value)}
              disabled={isLoading}
            >
              <option value="">Select patient</option>
              {filteredPatients.map((item) => (
                <option key={item.caseId} value={item.caseId}>
                  {item.patientName} — {item.caseName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </header>
  );
}